export default __webpack_public_path__ + "static/media/anniversary-banner.6b337240.webp";